import { commonMedia } from "./grapesjs-config";
export const nameCategoryBlocks = "Khối giao diện";
export const nameCategoryTemplates = "Mẫu hoàn chỉnh";
export const nameContactBlock = "Khối liên hệ";
export const nameLinkedCourseBlock = "Khối khóa học mẫu";
export const nameLecturersBlock = "Khối giảng viên";
export const nameBasicBlock = "Giao diện cơ bản";
export const nameCountBlocks = "Khối thống kê mẫu";
export const nameRoadMapBlocks = "Khối lộ trình khóa học";
export const nameHeaderBlocks = "Giới thiệu chung";
export const nameRegisterBlocks = "Khối ghi danh";
export const nameConditionBlocks = "Khối điều kiện";
export const nameAffiliatedBlocks = "Khối liên kết";

export const generalSearchCourseList = (data?: any) => {
  const blockUI = {
    id: "search-block-id",
    label: "Phần thanh tìm kiếm",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  blockUI.content = `
  <div>
    <div id="iuph" class="flex flex-col items-center justify-center text-white py-24" component-class="ProgramsBanner">
      <div id="i9fg" class="text-center max-w-2xl">
        <span id="ioszd" class="inline-block py-1 px-2 rounded text-xs font-medium tracking-widest mb-4 text-red-600">Danh sách chương trình học</span>
        <h1 id="ir54" class="text-4xl font-bold mb-8 text-gray-800">Các chương trình học
        </h1>
        <p id="i1l4g" class="text-lg mb-6 text-gray-500">Với 1.000+ các chương trình học với đa dạng chủ đề
        </p>
        <div class="flex justify-center w-full">
          <input type="text" placeholder="Nhập từ khoá cần tìm" id="i8ujj" class="w-full md:w-1/2 px-4 py-2 text-gray-700 focus:outline-none mr-2 rounded border"/>
          <button id="iytk3" class="text-white px-4 py-2 hover:bg-gray-700 rounded bg-red-600">Tìm kiếm</button>
        </div>
      </div>
    </div>
  </div>`;

  return blockUI;
};

export const fieldCourse = (data?: any) => {
  const blockUI = {
    id: "categories-block-id",
    label: "Phần nội dung",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  blockUI.content = `
   <div>
    <div  component-class="SearchEducationalPrograms">
    <section id="i4xe-2" class="text-gray-600 body-font">
    </section>
    <section id="i4xe-2" class="text-gray-600 body-font">
      <div id="ixht-2" class="container px-5 mx-auto py-8">
        <div id="ieau9-2" class="flex flex-col w-full mb-8">
          <h1 id="i11l-2" class="text-2xl font-medium title-font mb-4 sm:text-3xl">Tất cả chương trình học
          </h1>
        </div>
        <div id="iccjpk" class="flex flex-wrap -m-4">
          <div id="iuf75s" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="ibrl-2" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 id="ics33-2" class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="id6wj-2" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="idgsk1" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="i5c2mi" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="irplmw" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="izq9y3" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="iju0nl" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="i4lzeg" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="ixrwhs" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="idrhqs" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="ihpe8i" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="ib4lg1" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="iosebl" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="i6jk3k" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="iv29ww" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="ir0mon" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="i18d4y" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="iwh5cu" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="if0yhj" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="i8cigv" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="ibi8kd" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="i0ef9s" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="icb92y" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="idesvf" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="inbl1v" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="ijx6l7" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="iej376" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="i845zn" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="iu61xz" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="ihxyxg" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="i7ks7a" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="i7kw8d" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <div id="ie8lsk" class="lg:w-1/4 md:w-1/2 p-4 w-full">
            <a class="block relative h-48 rounded overflow-hidden"><img alt="ecommerce" src="https://dummyimage.com/420x260" class="object-cover object-center w-full h-full block"/></a>
            <div class="mt-4">
              <h3 id="ip5f36" class="text-gray-500 text-xs tracking-widest title-font mb-1">Đại học Quốc gia Hà Nội (VNU) 
              </h3>
              <h2 class="text-gray-900 title-font text-lg font-medium mb-2">Phiên dịch và dịch thuật
                <br/>
              </h2>
              <p id="iusotk" class="mt-1">những kiến thức cơ bản về các bình diện ngôn ngữ Anh và văn hoá các nước nói tiếng Anh
              </p>
            </div>
          </div>
          <section id="iayb" class="text-gray-600 body-font">
          </section>
        </div>
      </div>
      <div id="icl2y" class="container mx-auto p-5">
        <!-- Pagination Section -->
        <div class="flex justify-between items-center mb-6">
          <!-- Items per page selection -->
          <div>
            <label for="itemsPerPage" id="iy572" class="mr-2 text-gray-700">Khoá học / trang</label>
            <select id="itemsPerPage" class="border-gray-300 rounded-md shadow-sm p-2 border"><option value="10">10</option><option value="20">20</option><option value="30">30</option><option value="40">40</option><option value="50">50</option></select>
          </div>
          <!-- Pagination controls -->
          <div class="flex items-center">
            <button id="i4pfe" class="px-4 py-2 text-gray-700 hover:bg-gray-300 rounded mx-4">Trang trước</button>
            <ul id="iq1qr" class="flex list-none border-gray-300 overflow-hidden rounded">
              <li>
                <button id="i5f7a" class="px-4 py-2 hover:bg-gray-300 rounded bg-red-100 text-red-700">1</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">2</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">3</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">4</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">5</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">6</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">7</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">8</button>
              </li>
              <li>
                <button class="px-4 py-2 text-gray-700 bg-white hover:bg-gray-300">9</button>
              </li>
              <li>
                <button id="i3a0o" class="px-4 py-2 text-gray-700 hover:bg-gray-300">10</button>
              </li>
            </ul>
            <button id="i2h0g" class="px-4 py-2 text-gray-700 hover:bg-gray-300 rounded mx-4">Trang sau</button>
          </div>
          <!-- Go to page selection -->
          <div>
            <label for="goToPage" id="ixggg" class="mr-2 text-gray-700">Đi đến trang</label>
            <input type="number" id="goToPage" min="1" max="10" class="w-16 border-gray-300 rounded-md shadow-sm p-2 border"/>
          </div>
        </div>
      </div>
    </section>
    </div>
  </div>
  `;

  return blockUI;
};
